import { createContext } from 'react';

export const CookiegateContext = createContext({
  acceptedCookies: false,
  handleAcceptClick: () => {},
  handleAcceptKeyup: () => {},
});
